import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { type Contact } from 'entities/Contacts/model/Contact'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  ContactsOptInModalLocalStore,
  type IContactsOptInModalLocalConfigOptionsStore,
  type IContactsOptInModalLocalConfigStore,
} from 'widgets/ContactsOptInModal/store/contactsOptInModalLocalStore'

export class ContactsOptInModalStore {
  private _modalsMap: Map<string, ContactsOptInModalLocalStore> = new Map()
  private _modalActive = ''

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  addModal = (id: string, config: IContactsOptInModalLocalConfigStore) => {
    this._modalsMap.set(id, new ContactsOptInModalLocalStore(config, this._entities))
  }

  deleteModal = (id: string) => {
    this._modalsMap.delete(id)
  }

  handleOpen = (contacts: Contact[], options?: IContactsOptInModalLocalConfigOptionsStore) => {
    const id = `contacts_opt_in_modal_${nanoid()}`

    this._modalActive = id

    this.addModal(this._modalActive, {
      contacts: contacts,
      id: id,
      deleteModal: this.deleteModal,
      options: options,
    })
  }

  get active() {
    if (!this._modalActive) return

    return this._modalsMap.get(this._modalActive)
  }
}
